import { Components, Theme } from '@mui/material';

type CardComponentOverrides = Pick<
  Components<Theme>,
  | 'MuiCard'
  | 'MuiCardActionArea'
  | 'MuiCardActions'
  | 'MuiCardContent'
  | 'MuiCardHeader'
  | 'MuiCardMedia'
>;

export const cardComponentOverrides: CardComponentOverrides = {
  // TODO Stop restyling MUI components and wrap them in our own components
  MuiCard: {
    styleOverrides: {
      root: ({ theme }) => ({
        padding: theme.spacing(4, 0),
        overflow: 'clip',
      }),
    },
  },
  // TODO Stop restyling MUI components and wrap them in our own components
  MuiCardHeader: {
    styleOverrides: {
      root: ({ theme }) => ({
        padding: theme.spacing(4, 12),
      }),
      action: () => ({
        margin: 0,
      }),
    },
  },
  // TODO Stop restyling MUI components and wrap them in our own components
  MuiCardContent: {
    styleOverrides: {
      root: ({ theme }) => ({
        padding: theme.spacing(4, 12),
      }),
    },
  },
  // TODO Stop restyling MUI components and wrap them in our own components
  MuiCardActions: {
    styleOverrides: {
      root: ({ theme }) => ({
        padding: theme.spacing(4, 12),
      }),
    },
  },
};
